import type { EdgeTypes } from "@xyflow/react";
import { CustomEdge } from "./custom-edge";

export const edgeTypes: EdgeTypes = {
  custom: CustomEdge,
};

export { CustomEdge } from "./custom-edge";
export type { CustomEdgeData, LineStyle, ArrowMode, PathStyle } from "./custom-edge";
